import { ReactElement } from 'react';
import { toast } from 'react-toastify';

export const errorToast = (message: string | ReactElement, options = {}) => {
  toast.error(message, {
    autoClose: 10 * 1000,
    ...options
  });
};
/** The API's own message for a failed request, or the fallback. */
export const apiMessage = (error: any, fallback: string): string => {
  const message = error?.response?.data?.message;
  return Array.isArray(message) ? message.join(' ') : typeof message === 'string' && message ? message : fallback;
};

export const warnToast = (message: string  |  ReactElement, options = {}) => {
  toast.warning(message, {
    autoClose: 10 * 1000,
    ...options
  });
};
